import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useTransition } from "react";
import { Tabs } from "antd";
import { useEffect } from "react";
import { generatePath, matchRoutes, useLocation, useNavigate } from "react-router-dom";
import { useLayoutNavigate } from "../../hooks/useLayoutNavigate";
import OperationRight from "./OperationRight";
import { TabsStyle } from "./styles";
import { useMemoizedFn } from "ahooks";
import { getChildPathname } from "../../../utils";
import { DEFAULT_ROUTE_ROOT } from "../../../utils/constants";
import { routesArraySelector, sendMessage, useAppStore, useMicroAppStore } from "../../../store";
import { getGlobalShareConfigValueByKey } from "../../../utils/globalShareConfig";
import { jsx as _jsx } from "react/jsx-runtime";
var LayoutTabs = function LayoutTabs(_ref) {
  var appData = _ref.appData,
    layoutConfig = _ref.layoutConfig;
  var _useTransition = useTransition(),
    _useTransition2 = _slicedToArray(_useTransition, 2),
    startTransition = _useTransition2[1];
  var microApps = useMicroAppStore(function (s) {
    return s.microApps;
  });
  var panes = useAppStore(function (s) {
    return s.panes;
  }, Object.is);
  var setPanes = useAppStore(function (s) {
    return s.setPanes;
  });
  var _useAppStore = useAppStore(function (s) {
      return s.tabCacheHandlers;
    }),
    removeCache = _useAppStore.removeCache;
  var addHistory = useAppStore(function (s) {
    return s.addHistory;
  });
  var removeHistory = useAppStore(function (s) {
    return s.removeHistory;
  });
  var setPathname = useAppStore(function (s) {
    return s.setPathname;
  });
  var innerPathname = useAppStore(function (s) {
    return s.pathname;
  });
  var setPageHandlers = useAppStore(function (s) {
    return s.setPageHandlers;
  });
  var flatPathRoutes = useAppStore(function (s) {
    return s.flatPathRoutes;
  });
  var routesPaths = useAppStore(routesArraySelector);
  var _useLocation = useLocation(),
    pathname = _useLocation.pathname;
  var _ref2 = matchRoutes(routesPaths, pathname) || [],
    _ref3 = _slicedToArray(_ref2, 1),
    matchRoute = _ref3[0];
  var routes = appData.routes;
  var storeTabsMode = useAppStore(function (s) {
    return s.tabsMode;
  });
  var tabsMode = getGlobalShareConfigValueByKey("tabsMode") || storeTabsMode;
  var _useLayoutNavigate = useLayoutNavigate(),
    navigateByPath = _useLayoutNavigate.navigateByPath;
  var navigate = useNavigate();
  var defaultHomePath = layoutConfig.homePath || DEFAULT_ROUTE_ROOT;
  useEffect(function () {
    if (!tabsMode) {
      return;
    }
    setTimeout(function () {
      if (!panes.some(function (item) {
        return item.path === defaultHomePath;
      })) {
        var defaultHomePane = flatPathRoutes[defaultHomePath];
        if (defaultHomePane) {
          setPanes([defaultHomePane].concat(_toConsumableArray(panes)));
        }
      }
    }, 0);
  }, [panes]);
  var onTabChange = function onTabChange(key) {
    setPathname(key);
    startTransition(function () {
      navigateByPath(key);
    });
  };
  var addTab = useMemoizedFn( /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref4) {
      var _Object$entries$find;
      var path, search, currentRoute, dynamicPath, $panes, isMicroApp, existingPane, willAddPanePath, localeRoute, willAddPane, mapPathname, microAppInfo, newPanes;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            path = _ref4.path, search = _ref4.search;
            if (matchRoute) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            currentRoute = flatPathRoutes[matchRoute.route.path];
            dynamicPath = currentRoute === null || currentRoute === void 0 ? void 0 : currentRoute.path; // TODO 可能会存在多个匹配的情况。user/123 和 user/234都匹配到/user/:id，面板就能打开多个
            $panes = _toConsumableArray(useAppStore.getState().panes);
            isMicroApp = false;
            existingPane = $panes.find(function (c) {
              if (c.path === path) {
                if (c.microAppPath === path) {
                  isMicroApp = true;
                }
                return true;
              }
              return false;
            }); // 已有现存
            if (!existingPane) {
              _context.next = 12;
              break;
            }
            addHistory(existingPane.path, search);
            if (existingPane.search !== search) {
              existingPane.search = search;
              setPanes($panes);
            }
            return _context.abrupt("return");
          case 12:
            // 在权限菜单中匹配
            willAddPanePath = Object.keys(flatPathRoutes).find(function (menuPath) {
              var menu = flatPathRoutes[menuPath];
              if (menuPath === dynamicPath) {
                if (microApps.some(function (m) {
                  return path.startsWith(m.baseRoute);
                })) {
                  isMicroApp = true;
                }
                if (menu.microAppPath) {
                  isMicroApp = true;
                }
                return true;
              }
              return false;
            });
            localeRoute = isMicroApp ? flatPathRoutes[willAddPanePath || ""] : (_Object$entries$find = Object.entries(routes).find(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 2),
                route = _ref7[1];
              return route.path === willAddPanePath;
            })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1]; // 可能为404
            willAddPane = willAddPanePath ? localeRoute : {
              id: "@@404",
              path: path,
              name: "PageNotFound",
              keepAlive: false
            }; // 子路由应与父路由同路径，将path和id覆盖
            // const subRouteId = Object.keys(appData.routes).find((key) => {
            //   const parentId = appData.routes[key].parentId;
            //   const prevId = +key! - 1;
            //   if (willAddPane.id && parentId === willAddPane.id && willAddPane.id === prevId.toString()) {
            //     return true;
            //   }
            //   return false;
            // });
            // if(subRouteId){
            //   willAddPane = appData.routes[subRouteId]
            // }
            mapPathname = isMicroApp && willAddPane.microAppPath ? willAddPane.microAppPath : path; // 如果是子应用，把子应用的参数带上
            microAppInfo = microApps.find(function (app) {
              return mapPathname.startsWith(app.baseRoute);
            });
            willAddPane = _objectSpread(_objectSpread({}, willAddPane), {}, {
              path: path,
              dynamicPath: dynamicPath,
              search: search,
              microApp: microAppInfo,
              dynamicMicroAppPath: microAppInfo ? mapPathname : ""
            });
            addHistory(willAddPane.path, search);
            newPanes = [].concat(_toConsumableArray($panes.filter(function (el) {
              return el.id !== "@@404";
            })), [willAddPane]);
            setPanes(newPanes);
          case 21:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref5.apply(this, arguments);
    };
  }());
  var removeTab = useMemoizedFn( /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(e, options) {
      var path, willDelPane, newPanes, nextActiveRoutePath, _willDelPane$microApp, microAppPath, purePath, _ref9, _ref10, microMatchRoute, pathWithParams, _ref11, replace, redirectPath;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (tabsMode) {
              _context2.next = 3;
              break;
            }
            if (!e) {
              navigate(-1);
            }
            return _context2.abrupt("return", Promise.resolve());
          case 3:
            path = e || pathname;
            willDelPane = panes.find(function (pane) {
              return pane.path === path || pane.microAppPath === path;
            });
            newPanes = panes.filter(function (pane) {
              return pane.path !== (willDelPane === null || willDelPane === void 0 ? void 0 : willDelPane.path);
            });
            setPanes(newPanes);
            nextActiveRoutePath = removeHistory(path); // 通知子应用关闭相应面板
            if (willDelPane !== null && willDelPane !== void 0 && willDelPane.microApp) {
              microAppPath = (willDelPane === null || willDelPane === void 0 ? void 0 : willDelPane.microAppPath) || path;
              purePath = getChildPathname(microAppPath, willDelPane.microApp.baseRoute);
              _ref9 = matchRoutes(routesPaths, path) || [], _ref10 = _slicedToArray(_ref9, 1), microMatchRoute = _ref10[0];
              pathWithParams = generatePath(purePath, microMatchRoute.params || {});
              sendMessage(willDelPane === null || willDelPane === void 0 || (_willDelPane$microApp = willDelPane.microApp) === null || _willDelPane$microApp === void 0 ? void 0 : _willDelPane$microApp.name, {
                event: "tabRemoved",
                data: {
                  pathnames: [pathWithParams]
                }
              }, {
                sync: true
              });
            }
            // 关闭前台tab
            if (pathname === path) {
              _ref11 = options || {}, replace = _ref11.replace, redirectPath = _ref11.redirectPath;
              navigate(redirectPath || nextActiveRoutePath || DEFAULT_ROUTE_ROOT, {
                replace: redirectPath ? true : replace
              });
            }
            // 关闭缓存
            removeCache === null || removeCache === void 0 || removeCache(path);
            return _context2.abrupt("return", Promise.resolve());
          case 12:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function (_x2, _x3) {
      return _ref8.apply(this, arguments);
    };
  }());
  var handlePathChanged = useMemoizedFn( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
    var purePathname, matchRoute, redirectChildRoutePath;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          if (!(pathname === defaultHomePath || pathname === DEFAULT_ROUTE_ROOT)) {
            _context3.next = 3;
            break;
          }
          navigate(defaultHomePath);
          return _context3.abrupt("return");
        case 3:
          //TODO 需要考虑动态路由
          purePathname = pathname.endsWith("/") ? pathname.slice(0, pathname.length - 1) : pathname;
          matchRoute = flatPathRoutes[purePathname];
          if (!(matchRoute !== null && matchRoute !== void 0 && matchRoute.redirect)) {
            _context3.next = 9;
            break;
          }
          redirectChildRoutePath = matchRoute.redirect === "@@auto" ? Object.keys(flatPathRoutes).find(function (key) {
            return flatPathRoutes[key].parentPath === purePathname && !flatPathRoutes[key].hideInMenu;
          }) : Object.keys(flatPathRoutes).find(function (key) {
            return flatPathRoutes[key].path === matchRoute.redirect;
          });
          navigate(redirectChildRoutePath || purePathname, {
            replace: true
          });
          return _context3.abrupt("return");
        case 9:
          addTab({
            path: purePathname,
            search: location.search
          });
        case 10:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  })));
  useEffect(function () {
    setPathname(pathname);
    startTransition(function () {
      handlePathChanged();
    });
  }, [pathname]);
  useEffect(function () {
    setPageHandlers({
      add: navigateByPath,
      remove: removeTab,
      back: function back() {
        return navigate(-1);
      }
    });
  }, []);

  // 若是无tabs模式，下面的就都不用初始化了
  if (!tabsMode) {
    return null;
  }
  var tabItems = panes.map(function (pane) {
    return {
      label: pane.name,
      key: pane.path,
      closable: pane.path !== layoutConfig.homePath
    };
  });
  var OperationsSlot = {
    right: /*#__PURE__*/_jsx(OperationRight, {})
  };
  return panes.length > 0 ? /*#__PURE__*/_jsx(TabsStyle, {
    children: /*#__PURE__*/_jsx(Tabs, {
      animated: false,
      items: tabItems,
      type: "editable-card",
      hideAdd: true,
      onChange: onTabChange,
      onEdit: function onEdit(e) {
        return removeTab(e);
      },
      activeKey: innerPathname,
      tabBarExtraContent: OperationsSlot
    })
  }) : null;
};
export default LayoutTabs;